import "src/decidim/friendly_signup/setup_password"
import "src/decidim/friendly_signup/setup_validations"
import "src/decidim/friendly_signup/setup_confirmations"

// CSS
import "entrypoints/decidim_friendly_signup.scss";

// Images
require.context("../images", true)
